export default "__VITE_ASSET__C4EuIPb0__"